<!-- // ============================================
// 6. ProductOffers.vue
// ============================================ -->
<template>
    <div>
        <div v-if="offers.length > 0" class="mb-2">
            <button @click="showOffers = !showOffers" type="button" class="btn btn-default bid-history-link">
                [{{ offers.length }} {{ $t('ecommerce.offers') }}]
            </button>
        </div>
        
        <div v-if="showOffers" class="info-block">
            <h3>{{ $t('ecommerce.offers') }}</h3>
            <div class="table-responsive">
                <table v-if="offers && offers.length > 0" class="table modern-table">
                    <tbody>
                        <tr v-for="offer in offers" :key="offer.id">
                            <td v-if="user.id !== offer.user_id">{{ maskEmail(offer.user.email) }}</td>
                            <td class="bid-price">{{ formatPrice(offer.price) }}</td>
                            <td>{{ offer.created_at | moment }}</td>
                            <td>
                                <span class="badge" :class="getStatusClass(offer.status)">
                                    {{ getStatusLabel(offer.status) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div v-else class="empty-state">
                    {{ $t('product.noOffers') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from "@/services/helper";

export default {
    name: 'ProductOffers',
    props: {
        offers: {
            type: Array,
            required: true
        },
        user: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showOffers: false
        };
    },
    methods: {
        formatPrice: helper.formatPrice,
        maskEmail: helper.maskEmail,
        getStatusLabel(status) {
            const statuses = {
                0: this.$t('main.refused') || 'Refusé',
                1: this.$t('main.accepted') || 'Accepté',
                null: this.$t('main.onHold') || 'En attente',
            };
            return statuses[status] || status;
        },
        getStatusClass(status) {
            const classes = {
                0: 'badge-danger',
                1: 'badge-success',
                null: 'badge-warning',
            };
            return classes[status] || 'badge-secondary';
        }
    }
};
</script>

/* ============================================
   6. ProductOffers.vue - Component Specific Styles
   Import shared-components.css for common styles
   ============================================ */
<style scoped>
/* Table Styles - Unique to ProductOffers */
.table-responsive {
    background: white;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    overflow: hidden;
}

.modern-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin: 0;
}

.modern-table tbody tr {
    transition: all 0.2s ease;
    border-bottom: 1px solid var(--gray-100);
}

.modern-table tbody tr:last-child {
    border-bottom: none;
}

.modern-table tbody tr:hover {
    background: var(--gray-50);
    transform: scale(1.001);
}

.modern-table td {
    padding: 18px 20px;
    vertical-align: middle;
    border: none;
    color: var(--gray-700);
    font-size: 14px;
}

.modern-table td:first-child {
    font-weight: 600;
    color: var(--gray-800);
}

@media (max-width: 768px) {
    .modern-table td {
        padding: 12px 16px;
        font-size: 13px;
    }
}
</style>